import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async () => {
    const { data } = await ApiService.getDspGeoLocations();
    return data;
};

const useDspGeoLocationListQuery = () => {
    return useQuery({
        queryKey: ['dspGeoLocationList'],
        queryFn: () => fetchData(),
        staleTime: Infinity,
        enabled: false,
    });
};

export { useDspGeoLocationListQuery };
